<template>
    <v-img
        class="login-bg"
        :src="require('../assets/bg.jpg')"
        :lazy-src="require('../assets/bg.jpg')"
    >
        <div class="login">
            <v-content>
                <v-container class="fill-height" fluid>
                    <v-row align="center" justify="center">
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-card class="elevation-2 slicklogin-login-form">
                                <v-card-text class="justify-center">
                                    <v-img
                                        :src="require('../assets/tms-logo.png')"
                                        :lazy-src="
                                            require('../assets/tms-logo.png')
                                        "
                                        class="slicklogin-form-logo mt-3 mb-2"
                                        height="100px"
                                        contain
                                    ></v-img>
                                    <div class="slicklogin-form-portalname">
                                        Smiley & Feedback Tool - Reset Password
                                    </div>
                                </v-card-text>
                                <v-card-text v-for="(error, index) in errors" v-bind:key="index" class="red--text text-center py-0 subtitle-2">
                                    {{ error }}
                                </v-card-text>
                                <v-card-text v-if="!success">
                                    <v-form ref="form">
                                        <v-text-field
                                            class="slicklogin-form-input"
                                            v-model="newPassword"
                                            label="New Password"
                                            required
                                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="showPassword ? 'text' : 'password'"
                                            :rules="[
                                                v => !!v || 'This is required'
                                            ]"
                                            @click:append="showPassword = !showPassword"
                                        ></v-text-field>

                                        <v-text-field
                                            class="slicklogin-form-input"
                                            v-model="confirmPassword"
                                            label="Confirm Password"
                                            required
                                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="showPassword ? 'text' : 'password'"
                                            :rules="[
                                                v => !!v || 'This is required',
                                                v => v === newPassword || 'Password does not match'
                                            ]"
                                            @click:append="showPassword = !showPassword"
                                        ></v-text-field>
                                    </v-form>
                                </v-card-text>
                                <v-card-text v-if="!success">
                                    <v-btn
                                        color="primary"
                                        class="white--text text-capitalize mb-4"
                                        block
                                        elevation="0"
                                        @click="onConfirm"
                                        :loading="isLoading"
                                        >Set New Password</v-btn
                                    >
                                </v-card-text>
                                <v-card-text v-if="success">
                                    <v-alert type="success" class="subtitle-2">Password reset successfully</v-alert>
                                </v-card-text>
                                <v-card-text v-if="success">
                                    <v-btn
                                        color="primary"
                                        class="white--text text-capitalize mb-4"
                                        block
                                        elevation="0"
                                        @click="$router.push('/')"
                                        >Back to Login</v-btn
                                    >
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-content>
        </div>
    </v-img>
</template>

<script>
import { AUTH_REQUEST } from "../store/actions/auth";

export default {
    name: "login",
    data() {
        return {
            newPassword: null,
            confirmPassword: null,
            showPassword: false,
            isLoading: null,
            hasError: false,
            errors: [],
            success: false
        };
    },
    computed: {
        token() {
            return this.$route.query.token
        }
    },
    created() {
        if (this.token == null) {
            this.$router.push('/')
        }
    },
    components: {},
    methods: {
        onConfirm: function(e) {
            if (this.$refs.form.validate()) {
                this.isLoading = true;
                this.resetPassword();
            }
        },
        resetPassword: function() {
            this.hasError = false
            this.errors = []
            this.$http({
                method: 'post',
                url: `/password_reset/confirm/`,
                data: {
                    "password": this.confirmPassword,
                    "token": this.token
                }
            }).then(response => {
                console.log(response.data)
                if (response.data.status == "OK") {
                    this.success = true
                }
            }).catch(err => {
                console.error(err.response);
                this.hasError = true
                this.isLoading = false
                this.$refs.form.reset()

                if (err.response.data.password) {
                    err.response.data.password.forEach(element => {
                        this.errors.push(element)
                    });
                } else if (err.response.data.status == 'notfound') {
                    this.errors.push("Invalid token.")
                }
            });
        }
    }
};
</script>

<style scoped>
body,
html {
    height: 100%;
}
h1 {
    width: 100%;
}
.container,
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
    padding: 0;
}
.v-card {
    border-radius: 0 !important;
}
.login {
    height: 100%;
    box-shadow: 0 0 100px inset rgba(0, 0, 0, 1);
    background-image: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.8) 0%,
        transparent 100px
    );
}
.login-bg {
    box-shadow: inset 0 0 10px #000000;
    height: 100vh;
}
.slicklogin-login-form {
    margin-top: 150px;
    border-top: 4px solid #a7a284 !important;
}
.slicklogin-form-portalname {
    position: relative;
    top: -10px;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
}
.slicklogin-login-link {
    font-size: 14px;
    padding: 0px;
    line-height: 24px;
    color: #424242 !important;
    text-decoration: none !important;
}

.slicklogin-login-link:hover {
    color: #275598 !important;
    text-decoration: underline !important;
}

.slicklogin-form-input >>> .v-label {
    top: -2px !important;
    font-size: 0.8em;
}

.slicklogin-form-input >>> .v-label.v-label--active {
    top: 8px !important;
    font-size: 1em !important;
}

@media (max-width: 599px) {
    .slicklogin-login-form {
        margin-top: 0;
        width: 100%;
        height: 100%;
        border-top: 6px solid #275598 !important;
    }
}
</style>
